import debounce from "lodash/debounce"

const serviceConnectSearch = () => {
  const searchWrapper = document.querySelector("#service-search")
  const searchInput = searchWrapper?.querySelector("input") as HTMLInputElement
  if (searchInput) {
    const serviceName = searchInput.dataset.serviceName

    if (window.innerWidth < 724) { // match phone width, esbuild doesn't support variable export
      searchInput.placeholder = `Search ${serviceName}`
    }

    const serviceCards = Array.from(document.querySelectorAll(".service-card-list-item"))

    const searchableCards = serviceCards.map(card => ({
      element: card,
      serviceName: (card as HTMLElement).dataset.serviceName || ""
    }))

    // Lazy-load Fuse.js on first search (reduces initial bundle size)
    let fusePromise: Promise<{ search: (term: string) => Array<{ item: (typeof searchableCards)[number] }> }> | null = null
    const getFuse = () => {
      if (!fusePromise) {
        fusePromise = import("fuse.js").then(({ default: Fuse }) =>
          new Fuse(searchableCards, {
            keys: ["serviceName"],
            includeScore: true,
            threshold: 0.3, // Lower = more strict matching (0.0 = exact, 1.0 = match anything)
          })
        )
      }
      return fusePromise
    }

    const cleanSearch = () => {
      serviceCards.forEach((card, index) => {
        if (index < 12) {
          card.classList.remove("hide")
        } else {
          card.classList.add("hide")
        }
      })
    }

    const handleInput = async (event: Event) => {
      const searchTerm = (event.target as HTMLInputElement).value.toLowerCase().trim()

      if (searchTerm === "") {
        cleanSearch()
      } else {
        serviceCards.forEach(card => card.classList.add("hide"))

        const fuse = await getFuse()
        const results = fuse.search(searchTerm).slice(0, 12)
        results.forEach(result => result.item.element.classList.remove("hide"))
        window.App.Utils.logCustomDatadogAction?.("service_connect_filter_started")
      }
    }

    const debouncedHandleInput = debounce(handleInput, 250)

    searchInput.addEventListener("input", debouncedHandleInput)
    window.addEventListener(`clean-search:${searchWrapper?.id}`, cleanSearch)

    // Prefetch Fuse when idle to reduce first-type lag (same as universal search header).
    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(() => getFuse(), { timeout: 2000 })
    } else {
      setTimeout(() => getFuse(), 1)
    }
  }
}

export default serviceConnectSearch
